import { WidgetsReturnsMain } from '@/widgets/returns';

export const PagesReturnsMain = () => <WidgetsReturnsMain />;
